import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import UIBox from 'common/ui/components/UIBox';
import { DialogProps } from 'common/ui/hooks/useDialog';

type Props = DialogProps<void> & {
  entityType: string;
};

export const ConflictRefreshDialog = ({ isOpen, entityType }: Props) => {
  const onReload = () => window.location.reload();

  return (
    <Dialog open={isOpen}>
      <DialogTitle>Failed to save changes</DialogTitle>
      <DialogContent>
        <UIBox padding="bm">
          <DialogContentText>
            The {entityType} has been edited elsewhere since it was loaded. Reload the{' '}
            {entityType} to fetch the changes and continue editing.
          </DialogContentText>
        </UIBox>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onReload}>
          Reload now
        </Button>
      </DialogActions>
    </Dialog>
  );
};
